import React from 'react';
import {
  Snackbar,
  Alert,
  Box,
  Typography,
  useTheme,
} from '@mui/material';
import {
  Person as PersonIcon,
} from '@mui/icons-material';
import { getFirstName } from '../utils/profileUtils';

const WelcomeMessage = ({ showWelcome, onClose, userData }) => {
  const theme = useTheme();

  return (
    <Snackbar
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      open={showWelcome}
      onClose={onClose}
      sx={{ top: { xs: 16, sm: 24 } }}
    >
      <Alert
        severity="success"
        variant="filled"
        onClose={onClose}
        sx={{
          width: '100%',
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          alignItems: 'center',
        }}
        icon={<PersonIcon />}
      >
        <Box>
          <Typography sx={{ fontWeight: 600, mb: 0.5 }}>
            Welcome to your profile, {getFirstName(userData?.name)}!
          </Typography>
          <Typography variant="body2">
            Manage your account details and preferences in one place.
          </Typography>
        </Box>
      </Alert>
    </Snackbar>
  );
};

export default WelcomeMessage;

